import patient from './patient/patient.middleware';
import group from './group/group.middleware';
import settings from './settings/settings.middleware';

export default [
    patient,
    group,
    settings
]